export const deleteHolidaysInitState = {
	holidays: null,
	error: null,
	errorShow: false,
	loading: false,
};
